"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _icons = require("@material-ui/icons");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    button: {
      border: "1px solid ".concat(theme.palette.text.secondary),
      borderRadius: 1,
      padding: theme.spacing(0.5)
    },
    value: {
      borderBottom: "1px solid ".concat(theme.palette.text.secondary),
      display: 'inline-block',
      lineHeight: '2',
      margin: theme.spacing(0, 1),
      textAlign: 'center',
      width: 35
    }
  };
});
var NumberSlider = function NumberSlider(_ref) {
  var value = _ref.value,
    handleChange = _ref.handleChange,
    min = _ref.min,
    max = _ref.max;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: function onClick() {
      return handleChange(value + 1);
    },
    color: "default",
    className: classes.button,
    disabled: value >= max,
    "data-testid": "slider-add-btn",
    "aria-label": "plus"
  }, /*#__PURE__*/_react.default.createElement(_icons.Add, null)), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    dir: "ltr",
    className: classes.value,
    "data-testid": "slider-value"
  }, value), /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: function onClick() {
      return handleChange(value - 1);
    },
    color: "default",
    className: classes.button,
    disabled: value <= min,
    "data-testid": "slider-remove-btn",
    "aria-label": "minus"
  }, /*#__PURE__*/_react.default.createElement(_icons.Remove, null)));
};
NumberSlider.propTypes = {
  handleChange: _propTypes.default.func,
  max: _propTypes.default.number,
  min: _propTypes.default.number,
  value: _propTypes.default.number
};
var _default = exports.default = NumberSlider;